import React,{useState, useEffect} from 'react';
import {BrowserRouter as Router, Route,Switch, Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import logo from './logo.png';
import axios from 'axios';

const clienteAxios = axios.create({
    baseURL : process.env.REACT_APP_BACKEND_URL
});
const clienteAxiosDos = axios.create({
  baseURL:process.env.API_URL
})

const Navbar = () => {
return (
<nav className="navbar navbar-dark bg-dark">
  <div className ="container">
<a className="navbar-brand">Vimarx | MCC</a>
    </div>
</nav>

  )
}
const Solicitar = () => {
  const [credito,setCredito] = useState(138);
  const [cuota,setCuota] = useState(0)
  const [monto,setMonto] = useState(1000000);
  const [meses,setMeses] =useState(3);


const obtenerData = async () => {
  try {
    const resultado = await clienteAxiosDos.get(`/api/mol/get_tasa_prestamo`);
       setCredito(resultado.data);
    if (resultado) {
      obtenerFormula();
    }
  } catch (error) {
    console.log(error);
  }
};
useEffect(() => {
  obtenerData();
}, []);
  const solicitarCredito = async () =>{
    let objReq={
      nombre:"",
      dni:"",
      email:"",
      cuota:cuota.toString(),
      valor_prestamo:monto.toString(),
      meses:meses.toString()
    };
    
    const forminputs = await Swal.mixin({
      input: 'number',
      confirmButtonText: 'Siguiente &rarr;',
      showCancelButton: false,
      showCloseButton: true,
      confirmButtonColor: '#2870a9 ',
      cancelButtonColor: '#282737',
      progressSteps: ['1', '2','3','4']
    }).queue([
      {
        title:"Nombre Completo",
        text:"Ingrese su nombre y apellido.",
        input:'text'
      },
      {
        title: 'DNI O CUIT',
        text: 'Ingrese su DNI o CUIT.'
      },{
        title: 'Teléfono',
        text: 'Ingrese su número de celular.',
        input:"tel"
      },
      {title:"Email",
      text:"Ingrese su email de contacto",
      input:"email"
      }
]).then((result) => {
      if (result.value) {
        objReq.dni = result.value[1];
        objReq.nombre=result.value[0];
        objReq.telefono=result.value[2];
        objReq.email = result.value[3];
        
        Swal.fire({
          title: 'Gracias!',
          html: `
            <img src=${logo} style="margin-top:10px;margin-botton:10px;" width="140px"><br/><br/>

            En breve nuestro personal se comunicará contigo.

          `,
          showConfirmButton: false, // There won't be any confirm button
          showCloseButton: true,
        })
        return objReq;
      }
    })
    if (forminputs) {
      const resultado = await clienteAxiosDos.post(`/api/simulador/solicitar_prestamos`,forminputs);
    }

  }
  useEffect(()=> {
obtenerFormula();
  },[meses,monto,credito])
  const HandleChange = (e) =>{
    
    
    if(e.target.name === "montoName"){
    setMonto(e.target.value)}else{
      setMeses(e.target.value)
    }
  }
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value).replace(/\u00A0/g, ''); // Remove non-breaking space if present
  };
  const obtenerFormula = () =>{
    var x = monto * (credito/100/12) * Math.pow(((credito/100/12)+1),meses);
    var y = credito/100/12+1;
    var z = Math.pow(y, meses)-1;    // 49
    ;
    var resultado = (x/z).toFixed(2);
 
    
    setCuota(resultado) 
    
  }
  return (
    <div className="">
      <div className="container">
    <section className="white-bg request-credit pdTop0">
            <div className="container-card mb-0">
              <div className="row mt-3">
                <div className="col-lg-8 center-block text-center">
                    <div className="title animated fadeInDown" data-animation="fadeInDown">
                        <h2>Simulá Tu Préstamo</h2>
                        <div className="widget-separator"><span></span></div>
                    </div>
                </div>
                <div className="col imghide"><img src={logo} width="140px"/></div>

                </div>

                    <div className="row text-center" >
                        <div className="col-7 list">
                          <div className="row renglon align-middle">
                            <div className="col col-lg-5">
                              <div className="row">
                                <div className="col-2 iconos">
                                  <i className="fas fa-money-bill fa-lg"></i>
                                </div>
                                <div className="col my-auto"> 
                                 <p className="preguntas align-middle">¿Cuánto dinero necesitas?</p>
                          </div>
                              </div>
                            </div>
                            <div className="col margenes" style={{marginTop: "5.5%"}}>
                            <input type="range" className="" min="50000" max="30000000" step="50000" value={monto} onChange={HandleChange} name="montoName" />
                            </div>
                            <div className="col col-lg-2 my-auto">
                            <h4 className="font-moneda">{formatCurrency(monto)}</h4>
                            </div>
                            </div>
                            <div className="row renglon">
                            <div className="col col-lg-5">
                              <div className="row">
                                <div className="col-2 iconos">
                                  <i className="fas fa-calendar-alt fa-lg"></i>
                                </div>
                                <div className="col" height="100px"> 
                                 <p className="preguntas align-middle">¿A qué plazo quieres pagarlo?</p>
                          </div>
                              </div>
                            </div>
                            <div className="col margenes" style={{marginTop: "5.5%"}}>
                            <input type="range" className="col-sm" min="2" max="60" step="1" value={meses} name="mesesName" onChange={HandleChange} />
                            </div>
                            <div className="col col-lg-2 my-auto">
                            <h5 className="text-dark font-weight-bold">{meses} meses</h5>
                            </div>
                            </div>
                            
                        </div>
                        <div className="col-4 mt-3 container-info">
                            <p className="text-dark font-weight-normal">
                                {meses} CUOTAS DE
                            </p>
                                
                                <h2 className="font-moneda">{
                                formatCurrency(cuota)
                                }</h2>
                            <p className="">
                                <small>+ Gastos e impuestos</small><br/>
                                <small>* Cuota estimada</small>
                            </p>
                            <div className="tns">
                                <p>*Sujeto a aprobación crediticia</p>
{/*                                 <p>CFTNA: {credito.CFTNA}%   CFTEA: {credito.CFTEA}%</p>
 */}                            </div>
                            <div className="checkbox">
{/*                                 <a className="color-sec" href="terminos-y-condiciones.pdf" target="_blank">Ver términos y condiciones</a>
 */}                            </div>
                            <button  className="btn btn-dark text-light solicitar-btn mt-4" onClick={()=>{solicitarCredito()}}>Solicitá Tu Préstamo</button>
                        </div>
                    </div>

                </div>

        </section>
        </div>
        

    </div>
  )
}

function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route exact path={"/"} component={Solicitar} />
        <Route exact path={"/solicitar"} component={Solicitar} />
      </Switch>
    </Router>
  )
}

export default App;
